import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconFastCheckoutStyle0 = cosmosIconCss;

const CosmosIconFastCheckout$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFastCheckout extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'da90e6c10624df8641d6289d30c6ca3d31af574d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6e225ef0db8c5a90f4e9ef88bd0a980a33497abc', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd4effb36fb96501af5be0de1612ecc8da150e82d', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m20.945 9.607-1.452-4.268a.506.506 0 0 0-.47-.34H17.31l.4-1.36A.503.503 0 0 0 17.23 3H8.38a.495.495 0 0 0-.48.36L4.684 14.354a.504.504 0 0 0 .491.64h.31a2.22 2.22 0 0 0-.98 1.999 3.003 3.003 0 0 0 6.006 0 2.243 2.243 0 0 0-.98-2l3.452-.005a2.22 2.22 0 0 0-.981 1.999 2.997 2.997 0 1 0 5.995-.002 2.21 2.21 0 0 0-.969-1.997l2.144.006a.514.514 0 0 0 .48-.36l1.312-4.428a1.032 1.032 0 0 0-.02-.6ZM9.13 4.499h6.758l-2.623 8.996H6.508L9.13 4.499Zm9.29 8.996h-3.593l.88-2.999h3.595l-.881 2.999Zm-.12-6.997h-1.43l-.73 2.499h3.013l-.851-2.499Zm-3.294 11.988a1.5 1.5 0 1 1 .004-2.999 1.5 1.5 0 0 1-.004 2.999ZM6.012 16.99a1.5 1.5 0 1 0 2.998.003 1.5 1.5 0 0 0-2.998-.003ZM1.5 4a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 .5.5h3A.5.5 0 0 0 5 5v-.5a.5.5 0 0 0-.5-.5h-3Zm1 3.25a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-1ZM1 11a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V11Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconFastCheckoutStyle0; }
}, [1, "cosmos-icon-fast-checkout", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-fast-checkout"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-fast-checkout":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFastCheckout$1);
            }
            break;
    } });
}

const CosmosIconFastCheckout = CosmosIconFastCheckout$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFastCheckout, defineCustomElement };
